export var SuperImposedState;
(function (SuperImposedState) {
    SuperImposedState[SuperImposedState["Layered"] = 0] = "Layered";
    SuperImposedState[SuperImposedState["LayeredSorted"] = 1] = "LayeredSorted";
    SuperImposedState[SuperImposedState["Grid"] = 2] = "Grid";
    SuperImposedState[SuperImposedState["GridScaled"] = 3] = "GridScaled";
    SuperImposedState[SuperImposedState["GridAlpha"] = 4] = "GridAlpha";
})(SuperImposedState || (SuperImposedState = {}));
